import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form, Space, Steps, Result, Select } from "antd";
import { useStepsForm } from "sunflower-antd";

import { SelectProps } from "antd/lib/select";

import { AuthContext } from "../../../context/AuthContext";

import { getMemberApi } from "../../../services/Member/MemberApis";
import { getDocumentsApi } from "../../../services/Document/DocumentApis";
import { getGroupApi } from "../../../services/Group/GroupApis";

const { Step } = Steps;

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleGenerate?: Function | undefined;
  memberId: any;
}

const GenerateDocumentModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handleGenerate,
  memberId,
}) => {
  const { currentGroup } = useContext(AuthContext);
  const [memberDocuments, setMemberDocuments] = useState([]);
  const [documents, setDocuments] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedDocumentId, setSelectedDocumentId] = useState<any>(undefined);

  const filteredArray = documents.filter(
    (obj1: any) =>
      !memberDocuments.some(
        (obj2: any) =>
          obj1.id === obj2.DocumentID &&
          obj1.Html.length === obj2.DocumentHtml.length
      )
  );

  const document: SelectProps["options"] = filteredArray.map((doc: any) => {
    return {
      value: doc.id,
      label: doc.Name,
      key: doc.id,
    };
  });

  const onChangeDocument = async (e: any) => {
    setSelectedDocumentId(e);
    const { data } = await getDocumentsApi(currentGroup.id);

    const docType = data.filter((doc: any) => {
      return doc.id === e;
    });

    {
      form.setFieldsValue({
        DocumentType: docType[0].Type,
      });
    }
  };

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);
      if (!values.Document) {
        setErrorMsg("Please select a document.");
        setLoading(false);
        return false;
      }
      if (handleGenerate != undefined) {
        const response = await handleGenerate(
          values.Document,
          values.DocumentType
        );

        if (response?.success) {
          setLoading(false);
          return true;
        }
        setErrorMsg(response?.message ?? "Failed to generate document.");
        setLoading(false);
        return false;
      }
    },
    total: 4,
  });

  // Step Styling
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const display: any = {
    0: (
      <>
        <Form.Item name="Document" label="Document">
          <Select
            loading={fetchLoading}
            onChange={(e: any) => onChangeDocument(e)}
            id="Document"
            options={document}
            size="large"
            style={{ width: "100%" }}
            placeholder="Document"
          />
        </Form.Item>

        <Form.Item name="DocumentType" label="Document Type">
          <Select
            disabled={true}
            id="DocumentType"
            size="large"
            style={{ width: "100%" }}
            placeholder="Document Type"
          />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Button
              loading={loading}
              disabled={!selectedDocumentId}
              style={{ marginBottom: 10 }}
              block
              size="large"
              onClick={() => {
                submit().then((result: any) => {
                  if (result) {
                    gotoStep(current + 1);
                  } else if (!result) {
                    gotoStep(current + 2);
                  }
                });
              }}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </>
    ),
  };

  useEffect(() => {
    setFetchLoading(true);
    getMemberApi(memberId)
      .then((res) => {
        setMemberDocuments(res.data.PersonalDocument);
        getGroupApi(res.data.GroupID)
          .then((res) => {
            setDocuments([
              ...res.data.Document,
              ...res.data.CommunicationDocument,
            ]);
            setFetchLoading(false);
          })
          .catch((err) => {
            setFetchLoading(false);
            console.log(err);
          });
      })
      .catch((err) => {
        setFetchLoading(false);
        console.log(err);
      });
  }, []);

  return (
    <Modal
      title="Add Documents"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        {current === 1 && <></>}
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {display[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully generated document.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default GenerateDocumentModal;
